import { render, staticRenderFns } from "./table.vue?vue&type=template&id=49ce9561&scoped=true&lang=pug&"
import script from "./table.vue?vue&type=script&setup=true&lang=js&"
export * from "./table.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./table.vue?vue&type=style&index=0&id=49ce9561&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce9561",
  null
  
)

export default component.exports